import React from "react";
import { Row, Col, Breadcrumb, Dropdown } from "react-bootstrap";
import { FiHome, FiDownload, FiChevronUp } from "react-icons/fi";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import AttendanceDashboard from "../../components/administration/AttendanceDashboard";
import EmployeeAttendance from "../../components/administration/EmployeeAttendance";

const AttendanceReportPage =()=> {
  return (
    <Row 
style={{ padding: "16px", background: "#f8f9fa",  }} className="align-items-center justify-content-between page-breadcrumb  mb-3">

      {/* LEFT */}
    <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Attendance Report</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                     Adminstration
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Attendance Report</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

      {/* RIGHT */}
      <Col md="auto" className="d-flex align-items-center flex-wrap gap-2">

        {/* EXPORT DROPDOWN */}
        <Dropdown>
          <Dropdown.Toggle className="btn-white d-flex align-items-center">
            <FiDownload className="me-1" />
            Export
          </Dropdown.Toggle>

          <Dropdown.Menu align="end" className="dropdown-ui">
            <Dropdown.Item>
              Export as PDF
            </Dropdown.Item>
            <Dropdown.Item>
              Export as Excel
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {/* COLLAPSE ICON */}
        {/* <div className="collapse-icon">
          <FiChevronUp />
        </div> */}

      </Col>
      <AttendanceDashboard/>
      <style>
          {

               `/* HEADER */
.page-breadcrumb h2 {
  font-size: 22px;
  color: #111827;
}

/* BREADCRUMB */
.breadcrumb {
  font-size: 13px;
}

.breadcrumb-item + .breadcrumb-item::before {
  content: ">";
  color: #9ca3af;
}

/* BUTTON WHITE */
.btn-white {
  background: #fff !important;
  border: 1px solid #e5e7eb !important;
  color: #111827 !important;
  border-radius: 6px;
  padding: 6px 12px;
}

.btn-white:hover {
  background: #f9fafb !important;
}

/* DROPDOWN */
.dropdown-ui {
  padding: 10px;
  border-radius: 10px;
}

.dropdown-ui .dropdown-item:hover {
  background: #f26522 !important;
  color: #fff !important;
}

/* COLLAPSE ICON */
.collapse-icon {
  width: 36px;
  height: 36px;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
}

.collapse-icon:hover {
  background: #f9fafb;
}

/* MOBILE */
@media (max-width: 768px) {
  .page-breadcrumb {
    flex-direction: column;
    align-items: flex-start !important;
  }
}`
          }
      </style>
      <EmployeeAttendance/>
    </Row>
  );
}
export default AttendanceReportPage;